import React from "react";
import PropTypes from "prop-types";

class AddPostForm extends React.Component {
  placeRef = React.createRef();
  yearRef = React.createRef();
  descRef = React.createRef();
  imageRef = React.createRef();

  static propTypes = {
    addPost: PropTypes.func.isRequired
  };

  createPost = (event) => {
    // 1. stop the form from submitting
    event.preventDefault();
    const post = {
      place: this.placeRef.current.value,
      year: parseFloat(this.yearRef.current.value),
      desc: this.descRef.current.value,
      image: this.imageRef.current.value
    };
    this.props.addPost(post);
    // refresh the form
    event.currentTarget.reset();
  };

  render () {
    return (
      <form className="post-edit" onSubmit={this.createPost}>
        <input name="place" ref={this.placeRef} type="text" placeholder="Place" />
        <input name="year" ref={this.yearRef} type="text" placeholder="Year" />
        <textarea name="desc" ref={this.descRef} placeholder="Text"></textarea>
        <input name="image" ref={this.imageRef} type="text" placeholder="Image URL" />
        <button type="submit">+ Add Post</button>
      </form>
    );
  }
}

export default AddPostForm;